<template>
    <v-btn v-if="$breakpoint.smAndDown" block color="primary" class="sticky" @click="$emit('show-offers')">
        {{ $t('view_offers') }}
    </v-btn>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class ViewOffersButton extends Vue {}

    export default ViewOffersButton
</script>

<style scoped>
    .sticky {
        position: sticky;
        bottom: 8px;
        left: 0;
    }
</style>
